import { jsx as l } from "react/jsx-runtime";
const t = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M12.052 3.286c1.852 0 3.77.067 5.49.202 2.249.202 4.1 1.956 4.299 4.316l.023.407.024.518q.036.85.072 3.863l-.012.651a75 75 0 0 1-.107 2.867c-.198 2.36-2.05 4.113-4.3 4.316-1.563.122-3.29.19-4.983.2l-.51.002c-1.853 0-3.77-.068-5.49-.202-2.25-.203-4.101-1.956-4.3-4.316l-.023-.408-.017-.346a100 100 0 0 1-.075-2.556v-1.687l.013-.646c.025-1.055.06-1.996.102-2.663.199-2.36 2.05-4.114 4.3-4.316 1.563-.122 3.29-.19 4.983-.2zM12.05 6.59l-.606.002-.585.008c-1.365.024-2.72.088-4.037.191-.727.068-1.257.607-1.323 1.282l-.022.242c-.06.72-.1 1.731-.123 2.842v1.597l.014.61c.027.993.07 1.87.131 2.475.066.674.596 1.214 1.323 1.281a67 67 0 0 0 4.037.192l.585.008.646.002.565-.002a68 68 0 0 0 4.622-.2c.728-.067 1.257-.606 1.323-1.28l.022-.243c.075-.882.117-2.2.137-3.602l-.013-.838-.015-.609c-.027-.994-.07-1.87-.131-2.476-.066-.674-.595-1.213-1.323-1.28A67 67 0 0 0 13.24 6.6l-.585-.008z"
      }
    )
  }
);
export {
  t as default
};
